module.exports = __webpack_public_path__ + "img/robin-clipart-silhouette-2.6e70f6c8.png";